import { KeyValue } from "@/main/models/common";

export enum AddressTypeTypes {
	GET_ADDRESS_TYPE = "@addressType/GET_ADDRESS_TYPE",
	GET_ADDRESS_TYPE_PUBLIC = "@addressType/GET_ADDRESS_TYPE_PUBLIC",
	SAVE_ADDRESS_TYPE = "@addressType/SAVE_ADDRESS_TYPE",
	SAVE_ADDRESS_TYPE_PUBLIC = "@addressType/SAVE_ADDRESS_TYPE_PUBLIC",
	RESET_REDUCER_ADDRESS_TYPE = "@addressType/RESET_REDUCER_ADDRESS_TYPE",
}

export interface AddressTypeState {
	readonly addressType: {
		data: KeyValue[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetAddressType {
	type: typeof AddressTypeTypes.GET_ADDRESS_TYPE;
}

export interface GetAddressTypePublic {
	type: typeof AddressTypeTypes.GET_ADDRESS_TYPE_PUBLIC;
}

export interface SaveAddressType {
	type: typeof AddressTypeTypes.SAVE_ADDRESS_TYPE;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface SaveAddressTypePublic {
	type: typeof AddressTypeTypes.SAVE_ADDRESS_TYPE_PUBLIC;
	payload: {
		data: KeyValue[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerAddressType {
	type: typeof AddressTypeTypes.RESET_REDUCER_ADDRESS_TYPE;
}

export type AddressTypeActionTypes =
	| GetAddressType
	| GetAddressTypePublic
	| SaveAddressType
	| SaveAddressTypePublic
	| ResetReducerAddressType;
